import { iEdit } from '@hover/icons';
import React from 'react';

import type { AiDisplayImageFragment } from 'src/shared/graphql/generated';
import { useButtonImpression } from 'src/shared/hooks';
import { buttonPressed } from 'src/shared/telemetry';

import {
  useCustomizeHandler,
  useHomeownerAppContext,
  useHomeownerTranslate,
} from '../../hooks';
import type { TileButtonProps } from '../TileButton';
import { TileIconButton } from '../TileButton';

export interface CustomizeButtonProps
  extends Omit<TileButtonProps, 'label' | 'icon'> {
  image: AiDisplayImageFragment;
  trackingData: {
    track_id: string;
    view_type: string;
  };
}

const CustomizeTileIconButton = ({
  image,
  trackingData: trackingDataProp,
  ...props
}: CustomizeButtonProps) => {
  const t = useHomeownerTranslate();

  const { trackingData: contextTrackingData } = useHomeownerAppContext();
  const customizeText = t('paint.customize');

  const { onClick, tracking: customizeTrackingData } = useCustomizeHandler({
    image,
  });

  const trackingData = {
    ...contextTrackingData,
    ...trackingDataProp,
    button_text: customizeText,
    primary_cta: false,
    space_type: image.spaceType ?? undefined,
    ...customizeTrackingData,
  };

  useButtonImpression(trackingData);

  const handleClick = () => {
    buttonPressed(trackingData);

    void onClick();
  };

  return (
    <TileIconButton
      icon={iEdit}
      label={customizeText}
      onClick={handleClick}
      {...props}
    />
  );
};

export { CustomizeTileIconButton };
